import Vuex from "vuex";
import Vue from "vue";
import { users } from "./modules/user";
import { alert } from "./modules/alert";
import { companies } from "./modules/company";
import { languages } from "./modules/language";
import { applications } from "./modules/application";
import { tagData } from "./modules/tagdata";
import { tag } from "./modules/tag";
import { alarms } from "./modules/alarm";
import { scripts } from "./modules/scripts";
import { reports } from "./modules/report";
import { dashboards } from "./modules/dashboard";
import { modules } from "./modules/modules";
import { logs } from "./modules/log";
import { configuration } from "./modules/configuration";
import { settings } from "./modules/settings";
import { notifications } from "./modules/notification";
import { signalTests } from "./modules/signalTest";
import { gateways } from "./modules/gateway";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    users,
    companies,
    tag,
    alert,
    languages,
    applications,
    tagData,
    alarms,
    scripts,
    reports,
    dashboards,
    modules,
    logs,
    configuration,
    settings,
    notifications,
    signalTests,
    gateways,
  },
  plugins: [createPersistedState()],
});
